import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { OrgModelListResponse } from "../OrgLlmProviderRecord";

import { orgQueryKeys } from "./orgQueryKeys";

/** The org's chat model list and its own connections. Readable by any member of the org. */
export function useOrgLlmProvider(orgId: string) {
  const { orgService } = useDomainServices();

  return useQuery<OrgModelListResponse, Error>({
    queryKey: orgQueryKeys.llmProvider(orgId),
    queryFn: ({ signal }) =>
      orgService.getOrgLlmProvider(orgId, { abortSignal: signal }),
  });
}
